/**
 * Session 31 · Meta Pixel Loader (idempotent, testmode-aware).
 *
 * Regeln:
 *  - Wird ausschließlich nach Marketing-Consent aufgerufen.
 *  - Kein Advanced Matching im Browser (Server erledigt CAPI).
 *  - Bei TEST_MODE keine echten Netzwerkanfragen.
 */

const PIXEL_SCRIPT_ID = "pb24-meta-pixel-script";

let _initialized = false;
let _pixelId = null;
let _testMode = true;

function loadStub() {
  if (window.fbq) return;
  /* eslint-disable */
  const n = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  /* eslint-enable */
}

export function initMetaPixel({ pixelId, testMode }) {
  if (_initialized) return true;
  if (!pixelId) return false;
  _pixelId = pixelId;
  _testMode = !!testMode;

  loadStub();

  // Idempotent: Script-Tag nur einmal einfügen
  if (!document.getElementById(PIXEL_SCRIPT_ID) && !_testMode) {
    const s = document.createElement("script");
    s.id = PIXEL_SCRIPT_ID;
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  }

  try {
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
  } catch (_) { /* noop */ }

  _initialized = true;
  return true;
}

export function fbqTrack(eventName, params = {}) {
  if (!_initialized || _testMode) return;
  // eventID gehört in das 4. Argument (Abgleich mit der Conversions API), nicht in die Event-Daten
  const { eventID, ...data } = params || {};
  try { eventID ? window.fbq("track", eventName, data, { eventID }) : window.fbq("track", eventName, data); } catch (_) { /* noop */ }
}

// Session 36f · Once-Guards für Events die pro Session/Buchung nur einmal
// feuern dürfen (InitiateCheckout, AddPaymentInfo, Purchase, ViewContent).
function _once(key) {
  try {
    if (window.sessionStorage.getItem(key)) return false;
    window.sessionStorage.setItem(key, String(Date.now()));
    return true;
  } catch (_) { return true; }
}

export function trackViewContentOnce(name, extra = {}) {
  if (!_once(`pb24_vc_${name}`)) return;
  fbqTrack("ViewContent", { content_name: name, ...extra });
}

export function trackInitiateCheckoutOnce(params = {}) {
  if (!_once("pb24_ic_once")) return;
  fbqTrack("InitiateCheckout", params);
}

export function trackAddPaymentInfoOnce(params = {}) {
  if (!_once("pb24_api_once")) return;
  fbqTrack("AddPaymentInfo", params);
}

/**
 * Session 36f · Purchase mit event_id = booking_id für Server/Client-Dedup.
 * Feuert pro Buchung genau einmal (persistenter Guard in localStorage, damit
 * auch ein Reload oder späteres Öffnen der Erfolgsseite kein zweites Event
 * auslöst).
 */
export function trackPurchaseOnce(bookingId, params = {}) {
  if (!bookingId) return false;
  const key = `pb24_purchase_${bookingId}`;
  try {
    if (window.localStorage.getItem(key)) return false;
    window.localStorage.setItem(key, String(Date.now()));
  } catch (_) { /* fallback: fire ohne Guard */ }
  if (!_initialized || _testMode) return true;
  try {
    window.fbq("track", "Purchase", params, { eventID: bookingId });
  } catch (_) { /* noop */ }
  return true;
}

export function isMetaPixelInitialized() {
  return _initialized;
}

/** Nur für Tests / Consent-Widerruf: markiert Loader als „nicht mehr feuern". */
export function disableMetaPixel() {
  _initialized = false;
}
